<template>
	<div class="saas-product-apply-wrapper">
		<el-button id="btn-open-saas-product-apply-modal" hidden @click="handleOpenSaaSProductApplyModal" />
		<el-button id="btn-close-saas-product-apply-modal" hidden @click="handleCloseSaaSProductApplyModal" />
		<!-- 開通應用 Modal -->
		<el-dialog modal-class="saas-product-apply-modal" v-model="dialogFormVisible" :fullscreen="isMobile"
			:width="isMobile ? '90%' : '600px'" destroy-on-close lock-scroll show-close top>
			<div style="margin-bottom: 60px;">
				<el-form :model="form" :label-position="isMobile ? 'top' : 'right'">
					<el-form-item v-if="optionalSaasPages.length" label="應用帳戶" :label-width="formLabelWidth">
						<el-select v-model="form.client_page_id" placeholder="請選擇" size="large" style="width: 100%"
							fit-input-width>
							<el-option v-for="item in optionalSaasPages" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
					</el-form-item>
					<el-form-item
						v-if="!optionalSaasPages.length || form.client_page_id === '00000000-0000-0000-0000-000000000000'"
						label="應用帳戶名" :label-width="formLabelWidth">
						<el-input v-model="form.client_page_name" autocomplete="off" size="large" />
					</el-form-item>
					<template v-if="platform !== 'FBMSN'">
						<el-form-item v-if="optionalCompanies.length" label="公司" :label-width="formLabelWidth">
							<el-select v-model="form.client_co_id" placeholder="請選擇" size="large" style="width: 100%"
								fit-input-width>
								<el-option v-for="item in optionalCompanies" :key="item.value" :label="item.label"
									:value="item.value" />
							</el-select>
						</el-form-item>
						<el-form-item v-else label="公司名" :label-width="formLabelWidth">
							<el-input v-model="form.client_co_name" autocomplete="off" size="large" />
						</el-form-item>
					</template>
					<el-form-item v-if="requiredFields.includes('email')" label="E-mail" :label-width="formLabelWidth">
						<el-input v-model="form.email" autocomplete="off" size="large" />
					</el-form-item>
					<!-- <el-form-item v-if="requiredFields.includes('mobile')" label="手機號碼" :label-width="formLabelWidth">
						<el-input v-model="form.mobile" autocomplete="off" size="large" />
					</el-form-item> -->
				</el-form>
			</div>
			<template #title>
				<h6>
					<span style="font-weight: 400;">開通應用 - </span>
					{{ dt(product.name_translations) }}
				</h6>
			</template>
			<template #footer>
				<div class="fixed-footer d-flex" style="justify-content: space-between; align-items: end;">
					<el-button size="large" @click="handleCloseSaaSProductApplyModal()">
						取消
					</el-button>
					<el-button size="large" type="primary" @click="handleConfirmSaaSProductApply()"
						style="font-size: 130%; height:60px; width: 200px;">
						確認開通
					</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { breakpoint, dataTranslations as dt } from "../../utils"
import { useVModel } from '@vueuse/core'
import { ElLoading } from 'element-plus'

const props = defineProps({
	product: Object,
})

const isMobile = computed(() => breakpoint.value.xs)
const dialogFormVisible = ref(false)

const optionalSaasPages = ref([]);
const optionalCompanies = ref([]);
const isSaaSAgentUser = computed(() => {
	const { SaaSAgentUserIds, SaaSUser } = window;
	return SaaSUser?.id && SaaSAgentUserIds?.includes(SaaSUser?.id);
});

const form = reactive({
	client_page_id: null,
	client_page_name: null,
	client_co_id: null,
	client_co_name: null,
	email: null,
	// mobile: null,
})

const formLabelWidth = '100px';

const requiredFields = computed(() => product.saas.required_fields);

const platform = computed(() => product.saas?.app_info?.settings?.platform || "AIB");

const handleOpenSaaSProductApplyModal = () => {
	const cbOpen = ({ saas_pages, companies, user }) => {
		if (saas_pages && saas_pages?.length) {
			optionalSaasPages.value = saas_pages.map((i) => ({
				label: i.name,
				value: i.id,
			}));
			form.client_page_id = optionalSaasPages.value?.[0]?.value;
			form.client_page_name = null;
		} else {
			optionalSaasPages.value = [];
			form.client_page_id = null;
			form.client_page_name = `${user?.name}的應用帳戶`;
		}
		if (companies && Object.keys(companies)?.length) {
			optionalCompanies.value = Object.values(companies).map((i) => ({
				label: i.name,
				value: i.id,
			}));
			form.client_co_id = optionalCompanies.value?.[0]?.value;
			form.client_co_name = null;
		} else {
			optionalCompanies.value = [];
			form.client_co_id = null;
			form.client_co_name = `${user?.name}的公司`;
		}
		form.email = user.email;
		// form.mobile = user.phone_number;
		dialogFormVisible.value = true;
		if (isSaaSAgentUser.value && optionalSaasPages.value.length) {
			optionalSaasPages.value = [
				{
					label: '***建立新帳戶***',
					value: '00000000-0000-0000-0000-000000000000',
				},
				...optionalSaasPages.value,
			];
			form.client_page_id = optionalSaasPages.value?.[0]?.value;
			form.client_page_name = null;
		}
	}
	// read current user data
	if (window?.SaaSUser?.id) {
		const { SaaSUser: user, SaaSPages: saas_pages, SaaSCompanies: companies } = window;
		cbOpen({ saas_pages, companies, user });
	} else {
		window.jQuery('#loading').show();
		axios({
			method: 'GET',
			url: "/api/v1/auth/me",
			params: {
				fields: "saas",
			},
			headers: { 'Content-Type': 'application/json' },
		}).then((response) => {
			const { saas_pages, companies, user } = response?.data || {};
			cbOpen({ saas_pages, companies, user });
		}).catch((error) => {
			console.error(error);
			swal.fire({
				title: '系統發生錯誤了!',
				text: '讀取目前登入用戶資料發生異常！可能系統繁忙或網路不穩定，請稍候再試。',
				type: 'error',
			});
		}).finally(() => {
			window.jQuery('#loading').hide();
		});
	}
}

const handleCloseSaaSProductApplyModal = () => {
	dialogFormVisible.value = false;
}

const handleConfirmSaaSProductApply = () => {
	const loading = ElLoading.service({
		fullscreen: true,
		lock: true,
		text: '開通處理中...',
		background: 'rgba(0, 0, 0, 0.5)',
	});
	const applyUrl = '/api/v1/saas/product-apply'
	// 等待 task 拿執行結果（不斷等待）
	const getResultFromTaskUid = (task_uid) => {
		axios.get(applyUrl, { params: { task_uid } })
			.then((response) => {
				console.warn("getResultFromTaskUid", response);
				const { processed, success, error } = response?.data || {};
				if (!processed) {
					setTimeout(() => { getResultFromTaskUid(task_uid) }, 1000);
					return;
				}
				if (success) {
					handleCloseSaaSProductApplyModal();
					swal.fire({
						title: '開通成功!',
						type: "success",
						confirmButtonText: "開啟應用",
						allowOutsideClick: false,
					}).then(() => {
						window.location.href = "/goto-app/" + success?.from_task_uid;
					});
				} else if (error) {
					swal.fire({
						title: '開通失敗!',
						text: `${error?.msg || "未知原因"}`,
						footer: `${error?.type || "UNKNOWN_EXCEPTION"}`,
						type: 'error',
					});
				}
				loading.close();
			})
			.catch((error) => {
				console.error(error);
				swal.fire({
					title: '系統發生錯誤了!',
					text: '等待開通結果發生異常！可能系統繁忙或網路不穩定，請刷新頁面後重試。',
					type: 'error',
				}).then(() => {
					window.location.reload();
				});
				loading.close();
			});
	}
	// 送申請開通資料
	const applyData = {
		...form,
		store_product_id: props.product.id,
	};
	axios.post(applyUrl, applyData)
		.then((response) => {
			const task_uid = response.data?.task_uid;
			if (!task_uid) {
				console.warn("/api/v1/saas/product-apply response cannot found task_uid", response)
				swal.fire({
					title: '系統發生錯誤了!',
					text: '開通應用回傳資料發生異常！可能系統繁忙或網路不穩定，請刷新頁面後重試。',
					type: 'error',
				}).then(() => {
					window.location.reload();
				});
				return;
			}
			getResultFromTaskUid(task_uid);
		})
		.catch((error) => {
			console.error(error);
			const { msg, type } = error?.response?.data?.errors?.[0];
			if (msg) {
				swal.fire({
					title: `${msg}`,
					type: 'error',
					footer: `${type}`
				});
			} else {
				swal.fire({
					title: '系統發生錯誤了!',
					text: '開通應用回傳資料發生異常！可能系統繁忙或網路不穩定，請刷新頁面後重試。',
					type: 'error',
				}).then(() => {
					window.location.reload();
				});
			}
			loading.close();
		});
}

</script>
<style lang="scss">
.saas-product-apply-wrapper {
	.saas-product-apply-modal {
		// .el-dialog__header {
		// 	padding-top: 10px;
		// }

		.el-dialog__footer {
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			padding: 10px;
			background-color: #fff;
			/* Optional: Match the dialog background color */
			border-top: 1px solid #ebeef5;
			/* Optional: Add a border to separate the footer from the content */
		}

		.el-dialog__body {
			padding-bottom: 60px;
			/* Adjust this value based on the height of your footer to ensure content doesn't overlap with the footer */
		}
	}
}
</style>